module.exports = __webpack_public_path__ + "bi.bdca9026c05f9df1bb7b.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bi.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bi.svg
// module chunks = styles